<hr>
<mat-label>
    <mat-icon style="margin-right: 10px">move_up</mat-icon>
    <span style="position: relative; top: -6px">{{'general.offsetPosition' | transloco}} ({{'general.autoScale' | transloco}} {{model.autoScaling == '1' ? 'on' : 'off'}})</span>
</mat-label>

<div class="toggle-wrapper">
    <mat-slide-toggle [(ngModel)]="model.horizontalCenterChecked" (change)="onChange('horizontalCenter')" [disabled]="model.locked == 'true' || model.autoScaling === '1'">
        {{ 'general.horizontalCenter' | transloco }}
    </mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="model.verticalCenterChecked" (change)="onChange('verticalCenter')" [disabled]="model.locked == 'true' || model.autoScaling === '1'">
        {{ 'general.verticalCenter' | transloco }}
    </mat-slide-toggle>
</div>

<div class="trapezoid-wrapper">
    <div class="top-trapezoid trapezoid horizontal">
        <div class="input-wrapper">
            @if (!(model.verticalCenterChecked || model.locked == 'true' || model.autoScaling === '1')) {
                <input type="checkbox" [(ngModel)]="model.topChecked" (change)="onChange('top')">
                <input type="number" [(ngModel)]="model.top" (change)="onChange('top')" [disabled]="!model.topChecked" matTooltip="{{ 'general.top' | transloco }}">
            } @else if (model.verticalCenterChecked) {                <br>
                <input type="number" [(ngModel)]="model.verticalCenter" (change)="onChange('verticalCenter')" matTooltip="{{ 'general.verticalCenterOffset' | transloco }}">
            }
        </div>
    </div>
    <div class="bottom-trapezoid trapezoid horizontal">
        <div class="input-wrapper">
            @if (!(model.verticalCenterChecked || model.locked == 'true' || model.autoScaling === '1')) {
                <input type="checkbox" [(ngModel)]="model.bottomChecked" (change)="onChange('bottom')">
                <input type="number" [(ngModel)]="model.bottom" (change)="onChange('bottom')" [disabled]="!model.bottomChecked" matTooltip="{{ 'general.bottom' | transloco }}">
            }
        </div>
    </div>
    <div class="left-trapezoid trapezoid vertical">
        <div class="input-wrapper vertical">
            @if (!(model.horizontalCenterChecked || model.locked == 'true' || model.autoScaling === '1')) {
                <input type="checkbox" [(ngModel)]="model.leftChecked" (change)="onChange('left')">
                <input type="number" [(ngModel)]="model.left" (change)="onChange('left')" [disabled]="!model.leftChecked" matTooltip="{{ 'general.left' | transloco }}">
            } @else if (model.horizontalCenterChecked) {
                <input type="number" [(ngModel)]="model.horizontalCenter" (change)="onChange('horizontalCenter')" matTooltip="{{ 'general.horizontalCenterOffset' | transloco }}">
            }
        </div>
    </div>
    <div class="right-trapezoid trapezoid vertical">
        <div class="input-wrapper vertical">
            @if (!(model.horizontalCenterChecked || model.locked == 'true' || model.autoScaling === '1')) {
                <input type="checkbox" [(ngModel)]="model.rightChecked" (change)="onChange('right')">
                <input type="number" [(ngModel)]="model.right" (change)="onChange('right')" [disabled]="!model.rightChecked" matTooltip="{{ 'general.right' | transloco }}">
            }
        </div>
    </div>
</div>